import { loadAsset } from './assets.js';

function readFile(file, readMethod) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader[readMethod](file);
  });
}

export function readFileAsArrayBuffer(file) {
  return readFile(file, 'readAsArrayBuffer');
}

export function loadImage(source) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = source instanceof Blob ? window.URL.createObjectURL(source) : null;
    image.onload = () => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
      resolve(image);
    };
    image.onerror = (error) => {
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
      reject(error);
    };
    image.src = objectUrl || source;
  });
}

export function readFileAsDataUrl(file) {
  return readFile(file, 'readAsDataURL');
}

export async function readFileAsPdf(file) {
  const pdfjsLib = await loadAsset('pdfjsLib');
  const blob = file instanceof Blob ? file : new Blob([file]);
  const url = window.URL.createObjectURL(blob);

  try {
    return await pdfjsLib.getDocument(url).promise;
  } finally {
    window.URL.revokeObjectURL(url);
  }
}
